import { keyframeGroups } from '../animation/fading/shared-animation-data';
import { getV3dProcedures } from '../v3d-utils/get-v3d-procedures';

export const setActiveKeyframe = (frame: number) =>
  // getV3dProcedures().setActiveFrameForAllAnimations(frame);
  getV3dProcedures().setActiveFrameForAnimations(keyframeGroups.govie, frame);
